import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

import { useFormikContext } from 'formik';
import { CustomSVG, DateTimeSelect, PaddedPaper, ValidatedSwitch } from 'components';
import { ContentFragment } from 'api';

import GroupSelect from '../GroupSelect';

const useStyles = makeStyles(theme => ({
  paper: {
    width: '100%',
  },
  root: {
    marginTop: theme.spacing(2),
  },
}));

const PinPost: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext<ContentFragment>();
  const { pinned_end_at, is_pinned } = values;

  function onChangeDate(time: number) {
    setFieldValue('pinned_end_at', time);
  }

  return (
    <Grid item xs={12}>
      <PaddedPaper square>
        <Grid container alignItems="flex-start" wrap="nowrap">
          <Grid item xs={1}>
            <CustomSVG name="pin" color={is_pinned ? 'inherit' : 'disabled'} />
          </Grid>
          <Grid item container direction="column" xs={10}>
            <Grid item>
              <Typography variant="subtitle1">{t('posting:pin')}</Typography>
            </Grid>
            <Grid item>
              <Typography color="textSecondary">{t('posting:pinGuideline')}</Typography>
            </Grid>
          </Grid>
          <Grid item xs={1}>
            <ValidatedSwitch name="is_pinned" labelPlacement="bottom" />
          </Grid>
        </Grid>
        {is_pinned && (
          <Grid container className={classes.root}>
            <Grid item xs={1} />
            <Grid item xs={11} container spacing={2} wrap="nowrap">
              <Grid item xs={6}>
                <GroupSelect />
              </Grid>

              <Grid item xs={6}>
                <DateTimeSelect
                  label={t('common:expires')}
                  value={pinned_end_at}
                  setValue={onChangeDate}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
      </PaddedPaper>
    </Grid>
  );
};

export default PinPost;
